import axios from "axios";

// const BASE_URL_1 = "http://127.0.0.1:8080";
const BASE_URL_1 =
  "https://health-tracker-v20-server-production-8b0e.up.railway.app";

export default axios.create({
  baseURL: BASE_URL_1,
  // withCredentials: true,
});

export const axiosPrivate = axios.create({
  baseURL: BASE_URL_1,
  headers: {
    "Content-Type": "application/json",
    withCredentials: true,
  },
});
